import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Advice, Button } from '@Sage/hoi-poi-ui';
import { EntityCrudActions } from 'actions';
import { RATES } from 'constants/Entities';
import SettingsLayout from '../components/SettingsLayout';
import { getLiteral } from 'utils/getLiteral';
import { withStyles } from '../../../styles';

import Content from './components/Content';
import RatesCrud from './RatesCrud';
import styles from './styles';
import './styles.scss';

const RatesCreateButton = ({ create, initEntityCrud }) =>
    create ? (
        <Button
            type="secondary"
            onClick={() => initEntityCrud({ entity: RATES, avoidRedirects: true })}
        >
            {getLiteral('label_add_rate')}
        </Button>
    ) : null;

const propTypes = {
    styles: PropTypes.object,
    login: PropTypes.bool.isRequired,
};

@withStyles(styles)
class RatesManagement extends Component {
    state = { bottomElementHeight: 0 };

    componentDidMount() {
        if (this._contentTop && this._contentBottom) {
            this.calculateBottomElementHeight();
        }
    }

    componentDidUpdate() {
        const { login } = this.props;
        if (login && this.state.bottomElementHeight === 0) {
            this.calculateBottomElementHeight();
        }
    }

    calculateBottomElementHeight = () => {
        const topElementHeight = this._contentTop?.offsetHeight;
        const bottomElement = this._contentBottom;
        const paddingTop = parseInt(bottomElement.style.paddingTop.replace('px', ''), 10) || 0;
        const paddingBottom =
            parseInt(bottomElement.style.paddingBottom.replace('px', ''), 10) || 0;
        const offset = topElementHeight + paddingTop + paddingBottom;
        this.setState({ bottomElementHeight: offset });
    };

    calculateOffsetHeight = () => {
        const { bottomElementHeight } = this.state;
        let offset = 100;
        offset += 20;

        return bottomElementHeight + offset;
    };

    render() {
        const { styles, login, create, initEntityCrud } = this.props;
        const containerHeightOffset = this.calculateOffsetHeight();
        const containerHeightStyle = `calc(100vh - ${containerHeightOffset}px)`;
        return login ? (
            <SettingsLayout
                title={getLiteral('label_rates_management')}
                description={getLiteral('helptext_rates_explanation')}
            >
                <div style={styles.fullWidth} className="ratesManagement">
                    <div
                        ref={(c) => (this._contentTop = c)}
                        id="contentTop"
                        className="titleContainer"
                    >
                        <div style={styles.subtitle} className="rates-management-info-banner">
                            <Advice showCollapse={false} showIcon type="info">
                                {getLiteral('helptext_rates_management')}
                            </Advice>
                        </div>
                    </div>

                    <div
                        ref={(c) => (this._contentBottom = c)}
                        style={{ ...styles.container, height: containerHeightStyle }}
                    >
                        <div className="toolbarContainer">
                            <div style={styles.buttonCrud}>
                                <RatesCreateButton
                                    create={create}
                                    initEntityCrud={initEntityCrud}
                                />
                            </div>
                        </div>

                        <div style={styles.tableContainer}>
                            <Content />
                        </div>
                    </div>
                </div>
                <RatesCrud />
            </SettingsLayout>
        ) : null;
    }
}

RatesManagement.propTypes = propTypes;

function mapStateToProps(state) {
    const permissions = state.config.permission;
    return {
        login: state.config.login,
        create: permissions ? permissions.rates_add : false,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        initEntityCrud: bindActionCreators(EntityCrudActions, dispatch).init,
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(RatesManagement);
